// extracted by mini-css-extract-plugin
module.exports = {"header":"FundraiserHeader_header__qvlLL","headerimage":"FundraiserHeader_headerimage__vBwYH","fundraiserimage":"FundraiserHeader_fundraiserimage__E8YwI"};